
















































import { Component, Mixins } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { stringify } from 'csv-stringify';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';
import UserActivtyLogQuery from '~/queries/userActivityLog.gql';

@Component({ components: { TwoFactorAuthInputPrompt, DatePicker } })
export default class UserActivityLog extends Mixins(AuthQuery) {
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  acknowledgement = false;
  isDownloading = false;
  queryDateRange = null;

  async convertCsv(csvArray: any[]) {
    return new Promise((resolve, reject) => {
      stringify(csvArray, function(err, csvOutput) {
        if (err) {
          reject(err);
        } else {
          resolve(csvOutput);
        }
      });
    });
  }

  async downloadActivityLog() {
    this.isDownloading = true;

    const [startDate, endDate] = this.queryDateRange || [null, null];
    try {
      const client = this.$apolloProvider.clients.defaultClient;
      const results = await client.query({
        query: UserActivtyLogQuery,
        fetchPolicy: 'network-only',
        variables: {
          startDate,
          endDate,
        },
      });

      if (
        results?.data?.activityLog?.success &&
        results?.data?.activityLog?.actions?.length
      ) {
        const csvArray = results.data.activityLog.actions.map((action: any) => {
          const quantity =
            action.quantity === null || action.quantity === undefined
              ? ''
              : action.quantity;

          const usdPrice = action.usdPrice
            ? parseFloat(action.usdPrice.toFixed(2))
            : action.usdPrice;
          const currencyUsdPrice = action.currencyUsdPrice
            ? parseFloat(action.currencyUsdPrice.toFixed(2))
            : action.currencyUsdPrice;
          const gasCurrencyUsdPrice = action.gasCurrencyUsdPrice
            ? parseFloat(action.gasCurrencyUsdPrice.toFixed(2))
            : action.gasCurrencyUsdPrice;
          const gasTxFeeUsdPrice = action.gasTxFeeUsdPrice
            ? parseFloat(action.gasTxFeeUsdPrice.toFixed(2))
            : action.gasTxFeeUsdPrice;

          return [
            action.action,
            action.date,
            quantity,
            action.currency || '',
            action.flow || '',
            action.network || '',
            // currencyUsdPrice,
            // usdPrice,
            action.gasTxFeePrice || '',
            action.gasCurrency || '',
            // gasCurrencyUsdPrice,
            // gasTxFeeUsdPrice,
            action.fromAddress || '',
            action.toAddress || '',
            action.txHash || '',
            action.id,
            // action.status || '',
          ];
        });

        csvArray.splice(0, 0, [
          'Description',
          'Date',
          'Quantity',
          'Currency',
          'Account Flow',
          'Network',
          // 'Currency USD Price',
          // 'USD Price',
          'Gas TX Fee Price',
          'Gas Currency',
          // 'Gas Currency USD Price',
          // 'Gas TX Fee USD Price',
          'From Address',
          'To Address',
          'TX Hash',
          'ID',
          // 'Status',
        ]);

        const csvOutput = (await this.convertCsv(csvArray)) as string;

        const blob = new Blob([csvOutput], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Activity Log.csv';
        link.click();
        URL.revokeObjectURL(link.href);
      }

      this.isDownloading = false;
    } catch (error) {
      this.isDownloading = false;
      this.$sentry.captureException(error);
      this.updateSnackbarErrorText(
        this.$t('components.settings.userActivityLog.userActivityLogError'),
      );
      this.toggleErrorSnackbar();
      throw error;
    }
  }
}
